/*
 * Cart Drawer Recommendations – nur Add-to-Cart + Mobile Slider
 * Keine API-Calls – Produkte kommen direkt aus Liquid
 */
(function() {
  'use strict';

  function init() {
    bindAddButtons();
    initMobileDots();
    initDesktopSidebar();
  }

  /* ===== DESKTOP SIDEBAR ===== */
  function initDesktopSidebar() {
    var slot = document.querySelector('.cart-recs-desktop-slot');
    if (!slot) return;

    var cartDrawer = document.getElementById('CartDrawer');
    if (!cartDrawer) return;

    function showSidebar() { document.body.classList.add('js-cart-drawer-open'); }
    function hideSidebar() { document.body.classList.remove('js-cart-drawer-open'); }

    function checkCartDrawer() {
      // Impulse 7.x: #CartDrawer bekommt 'is-active' wenn offen
      var isOpen = cartDrawer.classList.contains('drawer--is-open') ||
                   cartDrawer.classList.contains('is-active') ||
                   cartDrawer.hasAttribute('open');
      isOpen ? showSidebar() : hideSidebar();
    }

    // Nur #CartDrawer beobachten – KEIN Body-Observer (würde Endlosschleife verursachen)
    new MutationObserver(checkCartDrawer)
      .observe(cartDrawer, { attributes: true, attributeFilter: ['class', 'open'] });

    // ESC-Taste
    document.addEventListener('keyup', function(e) {
      if (e.key === 'Escape') hideSidebar();
    });
  }

  /* ===== ADD TO CART ===== */
  function bindAddButtons() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-rec-add-btn]');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      if (btn.classList.contains('is-adding') || btn.classList.contains('is-added')) return;

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      btn.classList.add('is-adding');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
      })
      .then(function(res) {
        if (!res.ok) throw new Error();
        return res.json();
      })
      .then(function() {
        btn.classList.remove('is-adding');
        btn.classList.add('is-added');

        refreshDrawer();

        setTimeout(function() {
          btn.classList.remove('is-added');
        }, 2000);
      })
      .catch(function() {
        btn.classList.remove('is-adding');
      });
    });
  }

  function refreshDrawer() {
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:updated'));

    // Section Rendering Fallback
    fetch('/?section_id=cart-drawer')
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['[data-products]', '[data-subtotal]', '[data-discounts]'].forEach(function(sel) {
          var n = doc.querySelector(sel);
          var c = document.querySelector('#CartDrawer ' + sel);
          if (n && c) c.innerHTML = n.innerHTML;
        });

        fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
          document.querySelectorAll('[data-cart-count], .cart-link__count, .site-header__cart-count, .js-cart-count')
            .forEach(function(el) { el.textContent = cart.item_count; });
        });
      })
      .catch(function() {
        window.location.reload();
      });
  }

  /* ===== MOBILE SLIDER DOTS ===== */
  function initMobileDots() {
    var list = document.querySelector('[data-cart-recs-list]');
    var dotsContainer = document.querySelector('[data-cart-recs-dots]');
    if (!list || !dotsContainer) return;

    var cards = list.querySelectorAll('[data-cart-rec-card]');
    if (cards.length <= 1) return;

    for (var i = 0; i < cards.length; i++) {
      var dot = document.createElement('button');
      dot.className = 'cart-recs__dot' + (i === 0 ? ' is-active' : '');
      dot.dataset.index = i;
      dotsContainer.appendChild(dot);
    }

    var scrollTimer;
    list.addEventListener('scroll', function() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function() {
        var dots = dotsContainer.querySelectorAll('.cart-recs__dot');
        if (!cards.length) return;
        var idx = Math.round(list.scrollLeft / (cards[0].offsetWidth + 10));
        dots.forEach(function(d, i) { d.classList.toggle('is-active', i === idx); });
      }, 80);
    });

    dotsContainer.addEventListener('click', function(e) {
      var dot = e.target.closest('.cart-recs__dot');
      if (!dot) return;
      var idx = parseInt(dot.dataset.index, 10);
      if (cards[idx]) cards[idx].scrollIntoView({ behavior: 'smooth', inline: 'start' });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();